import tourdecLogo from 'assets/images/tourdec-logo.png'

// T057: Tourdec branding in the sidebar (replaces the old "E-Bikes" wordmark).
// The asset is a transparent-background PNG cropped to the wordmark + star, so it
// sits directly on the red sidebar — no white card, no surrounding whitespace.
function AppLogo() {
  return (
    <div className='block mx-auto'>
      <div className='flex flex-col items-center mx-auto'>
        <a href='/' className='flex flex-col items-center'>
          <img
            src={tourdecLogo}
            alt='Tourdec'
            className='mt-4 mb-2 w-28 h-auto object-contain'
          />
        </a>
      </div>
    </div>
  )
}

export default AppLogo
